import { safeGetItem, safeSetItem, safeRemoveItem } from './telegram/storage.js';
import { loadProtectedContent, initLoginForm, initSignupForm, checkMiniAppAutoLogin, handleUnauthorized } from './telegram/auth.js';
import { initHistory, goBack } from './telegram/nav.js';
import { initConfirm } from './telegram/confirm.js';
import { downloadAuthed } from './telegram/download.js';
import './telegram/back-button.js';

initHistory();

window.goBack = goBack;
window.safeGetItem = safeGetItem;
window.safeSetItem = safeSetItem;
window.safeRemoveItem = safeRemoveItem;
window.downloadAuthed = downloadAuthed;

// Defensive: covers popstate entries htmx doesn't own (e.g. initial loads
// where initHistory set {appIsRoot: true}). Primary fix lives on
// htmx:historyCacheMiss below — for htmx-owned entries.
window.addEventListener('popstate', (event) => {
	if (event.state && event.state.htmx) return;
	loadProtectedContent().catch(e => console.error(e));
});

document.addEventListener('DOMContentLoaded', function () {
	window.appBasePath = "/app";

	// Flip htmx's default no-swap-on-4xx so the server's error-page response
	// actually lands in the DOM. The central errorFunc renders 401/403/404/
	// 405/500 as full pages; without this flip those bodies get discarded.
	// 5xx swaps in too — errorFunc owns those responses, so the rendered page
	// is what arrives.
	if (window.htmx) {
		htmx.config.responseHandling = [
			{ code: "204", swap: false },
			{ code: "[23]..", swap: true },
			{ code: "[45]..", swap: true, error: true },
		];
	}

	initLoginForm();
	initSignupForm();
	initConfirm();
	checkMiniAppAutoLogin().catch(e => console.error(e));
	loadProtectedContent().catch(e => console.error(e));

	// Attach active Telegram session Bearer token to all HTMX requests
	document.body.addEventListener('htmx:configRequest', function(evt) {
		if (window.TelegramSession) {
			evt.detail.headers['Authorization'] = 'Bearer ' + window.TelegramSession;
		}
	});

	// Evict client-stored session token when logout is triggered
	document.body.addEventListener('htmx:afterRequest', function(evt) {
		if (evt.detail.xhr && evt.detail.pathInfo && evt.detail.pathInfo.requestPath === '/logout') {
			safeRemoveItem('session_token').catch(e => console.error(e));
			window.TelegramSession = null;
		}
	});

	// Short-circuit 401 BEFORE the swap fires — attempt self-healing recovery via initData
	// before falling back to navigating to /login
	document.body.addEventListener('htmx:beforeSwap', function(evt) {
		if (evt.detail.xhr && evt.detail.xhr.status === 401) {
			evt.detail.shouldSwap = false;
			const next = window.location.pathname + window.location.search;
			handleUnauthorized(next).catch(e => console.error(e));
		}
	});

	// htmx's loadHistoryFromServer uses raw XHR that bypasses htmx:configRequest
	// — so our Authorization header isn't attached and the server returns the
	// bootstrap shell. Cancel htmx's unauthenticated XHR on cache miss and do
	// our own authenticated fetch via loadProtectedContent (htmx.ajax →
	// configRequest → Bearer token).
	document.body.addEventListener('htmx:historyCacheMiss', function(evt) {
		evt.preventDefault();
		loadProtectedContent().catch(e => console.error(e));
	});
});